/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React, { useContext } from "react"
import { Card, ListGroup, Nav, Navbar } from "react-bootstrap"
import PerfectScrollbar from "react-perfect-scrollbar"

import NavGroup from "./NavGroup"
import { ConfigContext } from "../../../../contexts/ConfigContext"
import NavUserInfo from "./NavUserInfo/NavUserInfo"
import NavItem from "./NavItem"
import NavCollapse from "./NavCollapse"
import NavFooter from "./NavFooter/NavFooter"

const NavContent = ({ navigation }) => {
  const configContext = useContext(ConfigContext)
  const { layout } = configContext.state
  const loginId = sessionStorage.getItem("email")
  const navItems = navigation.map((item) => {
    switch (item.type) {
      case "collapse":
        return <NavCollapse key={item.id} collapse={item} type="main" />
      case "group":
        return (
          <NavGroup layout={layout} key={"nav-group-" + item.id} group={item} />
        )
      case "item":
        return <NavItem layout={layout} key={item.id} item={item} />
      default:
        return false
    }
  })

  let mainContent = ""

  mainContent = (
    <div className="navbar-content next-scroll">
      <PerfectScrollbar>
        <div style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between"
        }}>
          <div>
            <NavUserInfo loginId={loginId} />
            <ListGroup
              variant="flush"
              as="ul"
              bsPrefix=" "
              className="nav pcoded-inner-navbar"
              id="nav-ps-next"
            >
              {navItems}
            </ListGroup>
          </div>
          <NavFooter />
        </div>
      </PerfectScrollbar>
    </div>
  )

  return <>
    {mainContent}
  </>
}

export default NavContent
